<template>
  <el-form ref="authGroupForm" :model="data" :rules="rules" label-width="100px">
    <el-form-item label="父级权限" prop="parent_id">
      <el-cascader
        :options="optionData"
        :props="{value: 'id', label: 'title', checkStrictly: true}"
        @change="handleChange"
      />
    </el-form-item>
    <el-form-item label="名称" prop="title">
      <el-input v-model.trim="data.title" placeholder="请填写权限名称" />
    </el-form-item>

    <el-form-item label="权限描述" prop="description">
      <el-input v-model.trim="data.description" type="textarea" rows="6" placeholder="请填写权限描述" />
    </el-form-item>

    <el-form-item label="排序" prop="sort">
      <el-input v-model.trim="data.sort" placeholder="请填写排序" />
    </el-form-item>
    <el-form-item label="类型" prop="sort">
      <el-select v-model="data.type" class="add_name" placeholder="请选择类型">
          <el-option
            v-for="items in typeoption"
            :key="items.id"
            :label="items.title"
            :value="items.id"
          />
        </el-select>
    </el-form-item>
    <el-form-item label="组长" prop="sort">
      <el-autocomplete
        v-model="data.leaderId"
        :fetch-suggestions="querySearchAsync"
        placeholder="请输入内容"
        @select="handleSelect"
      />
    </el-form-item>
    <el-form-item label="状态" prop="status">
      <el-radio-group v-model="data.status">
        <el-radio :label="1">{{ '启用' }}</el-radio>
        <el-radio :label="0">{{ '禁用' }}</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item>
      <el-button type="primary" @click="submit">{{ '提交' }}</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import {
  groupChildrenList,
  createGroup
} from '@/api/authGroup'
import {
  getList
} from '@/api/admin'

export default {
  name: 'AuthGroupCreate',
  components: { },
  props: {
    item: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      rules: {
        parent_id: [
          { required: true, message: '父级权限不能为空', trigger: 'change' }
        ],
        title: [
          { required: true, message: '名称不能为空', trigger: 'blur' }
        ],
        sort: [
          { required: true, message: '排序不能为空', trigger: 'blur' }
        ]
      },
      data: {
        parent_id: null,
        title: '',
        description: '',
        sort: 100,
        status: 1,
        leaderId: undefined,
        type: null
      },
      // parentOptions: [
      //   { key: '0', display_name: '顶级分组' }
      // ],
      optionData: [{
        id: 0,
        title: '顶级分组'
      }], // 分组筛选列表
      // parentFilterOptions: []
      typeoption: [{
        id: 1,
        title: '内部'
      },{
        id: 2,
        title: '外部'
      }],
      activeId: undefined
    }
  },
  created() {
    this.getGroupChildrenList()
  },
  methods: {
    getGroupChildrenList() {
      groupChildrenList().then(res => {
        this.optionData.push(...res.data.list)
      })
    },
    resetQueryData() {
      this.data = {
        parent_id: '',
        title: '',
        description: '',
        sort: 100,
        status: 1,
        leaderId: undefined,
        type: null
      }
      this.item.dialogVisible = false
    },
    handleChange(e) {
      this.data.parent_id = e[e.length - 1]
    },
    submit() {
      createGroup({ ...this.data, leaderId: this.activeId ? this.activeId.id : undefined }).then(response => {
        this.$emit('updateList')
        this.resetQueryData()
        this.$message({
          message: '添加权限成功',
          type: 'success',
          duration: 2 * 1000
        })
      })
    },
    async querySearchAsync(queryString, cb) {
      const data = await getList()
      const newArr = data.data.list.map((item) => {
        return { ...item, value: item.realName, address: item.id }
      })
      cb(newArr)
    },
    handleSelect(item) {
      this.activeId = item
    }
  }
}
</script>
